import React from "react";
import withMediaQueries, { mediaQueriesList } from "../../../hoc/withMediaQueries";
import PropTypes from "prop-types";

import './card.scss';

export const HeaderImage = (props) => {
  const { index, imageSrc, imageAlt, imageStyling } = props;

  if (imageSrc) {
    return (
      <img className={imageStyling} src={imageSrc} alt={imageAlt}/>
    );
  } else {
    return (
      <svg className={imageStyling} width="80px" height="80px" viewBox="0 0 80 80" version="1.1"
        xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <circle className="circle" strokeWidth="3" cx="40" cy="40" r="38"/>
          <text className="img-text">
            <tspan x="28" y="57">{index}</tspan>
          </text>
        </g>
      </svg>
    );
  }
};

HeaderImage.propTypes = {
  index: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  imageStyling: PropTypes.string
};

export const Card = (props) => {
  const { index, borderStyle, imageSrc, imageAlt, imageStyling, shadow, text, textStyling, title, titleStyling, screenSizeUtils } = props;
  const { screenLargerThan } = screenSizeUtils;

  let marginBottom = 'mb-3', imageMargin = 'my-3';
  if (screenLargerThan(mediaQueriesList.sm)) {
    marginBottom = 'mb-5';
    imageMargin = 'mb-4';
  }

  let cardClassStyle = "card text-center";
  if (borderStyle) {
    cardClassStyle = cardClassStyle.concat(" ", borderStyle);
  }

  if (shadow) {
    cardClassStyle = cardClassStyle.concat(" ", "bottom-shadow");
  }

  let titleClassStyle = "card-title text-dark";
  if (titleStyling) {
    titleClassStyle = titleClassStyle.concat(" ", titleStyling);
  }

  let textClassStyle = "card-text";
  if (textStyling) {
    textClassStyle = textClassStyle.concat(" ", textStyling);
  }

  let cardImageStyle = "card-icon card-img-top";
  if (imageStyling) {
    cardImageStyle = cardImageStyle.concat(" ", imageStyling);
  } else {
    cardImageStyle = cardImageStyle.concat(" ", imageMargin);
  }

  return (
    <div className={`${cardClassStyle} ${marginBottom}`}>
      <HeaderImage index={index} imageSrc={imageSrc} imageAlt={imageAlt} imageStyling={cardImageStyle} />
      <div className="card-body">

        <h3 className={`${titleClassStyle} ${marginBottom}`}>{title}</h3>
        <p className={textClassStyle}>{text}</p>
      </div>
    </div>
  );
};

export default withMediaQueries(Card);

Card.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  textStyling: PropTypes.string,
  titleStyling: PropTypes.string,
  index: PropTypes.string,
  borderStyle: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  imageStyling: PropTypes.string,
  shadow: PropTypes.bool,
  screenSizeUtils: PropTypes.shape({
    mediaQueriesList: PropTypes.object,
    screenLargerThan: PropTypes.func.isRequired
  }).isRequired
};
